import Vue from 'vue';
import Router from 'vue-router';

import HomePage from '../home/HomePage'
import LoginPage from '../login/LoginPage'
import CheckoutPage from '../checkout/CheckoutPage'
import AddProductPage from '../add/Add'
import OrdersPage from '../orders/Orders'

Vue.use(Router);

export const router = new Router({
    mode: 'history',
    routes: [
        { path: '/', component: HomePage },
        { path: '/add', component: AddProductPage },
        { path: '/login', component: LoginPage },
        { path: '/checkout', component: CheckoutPage },
        { path: '/orders', component: OrdersPage },
        // otherwise redirect to home
        { path: '*', redirect: '/' }
    ]
});

router.beforeEach((to, from, next) => {
    const publicPages = ['/login'];
    const authRequired = !publicPages.includes(to.path);
    const loggedIn = localStorage.getItem('user');

    if (authRequired && !loggedIn) {
        return next('/login');
    }

    next();
})